import { TNodeID } from "./_generated/NodeTypes";
import { useSharedState, useSharedStateWriteOnly } from "./app/useSharedState";
import { ContextMenu } from "./context_menus/ContextMenu";
import "./EditorApp.css";
import { useEditorConnection } from "./hooks/useEditorConnection";
import { Properties } from "./Properties";
import Workspace from "./Workspace";

export default function EditorApp() {
  const [scene, setScene] = useSharedState("scene");
  const [, setAppMousePosition] = useSharedStateWriteOnly("appMousePosition");
  const [, setServerSocket] = useSharedStateWriteOnly("serverSocket");

  useEditorConnection();

  return (
    <div
      className="app"
      onPointerMove={(e) => {
        setAppMousePosition([e.clientX, e.clientY]);
      }}
    >
      <Workspace rootId={"0" as TNodeID<"app">} />
      <Properties />
      <ContextMenu />
    </div>
  );
}
